import React from 'react';
import { ContributorSection } from '../../../components/ContributorSection';
import { MoreOptionsSection } from '../../../components/MoreOptions';
import { ReviewCitingSection } from '../../../components/citing/ReviewCiting';
import { RecommendationBar } from '../../../components/Shared';
import { ReviewerRoleOptions, TabHeaders } from '../constants';
import { useFormikContext } from 'formik';
import GenericSection from '../../../components/GenericSection';
import COMMON_PUBINFO_SECTION_FIELDS from '../constants/fieldList/common';
import { ONLINE_PUBINFO_SECTION_FIELDS } from '../constants/fieldList/online';
import { showSources } from '../constants/utils';
var Online = function Online() {
  var PRINT_SECTION_TITLE_TEST_ID = 'online-pub-section-test-id';
  var printSectionTitle = function printSectionTitle(source) {
    return "".concat(source, " publication info");
  };
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var pubType = values.pubtype && values.pubtype.main;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RecommendationBar, null), /*#__PURE__*/React.createElement(ReviewCitingSection, {
    selectedTab: TabHeaders.ONLINE
  }), /*#__PURE__*/React.createElement(ContributorSection, {
    functionOptions: ReviewerRoleOptions
  }), pubType !== undefined && /*#__PURE__*/React.createElement(GenericSection, {
    name: pubType,
    sectionTitle: printSectionTitle(showSources(pubType)),
    fieldList: COMMON_PUBINFO_SECTION_FIELDS[showSources(pubType).toUpperCase()],
    "data-test": PRINT_SECTION_TITLE_TEST_ID,
    selectedTab: TabHeaders.ONLINE
  }), /*#__PURE__*/React.createElement(GenericSection, {
    name: "pubonline",
    sectionTitle: "Online publication info",
    fieldList: ONLINE_PUBINFO_SECTION_FIELDS,
    "data-test": PRINT_SECTION_TITLE_TEST_ID,
    selectedTab: TabHeaders.ONLINE
  }), /*#__PURE__*/React.createElement(MoreOptionsSection, null));
};
export default Online;